import { useEffect, useRef } from "react";
import Pusher from "pusher-js";

let pusherInstance = null;

function getPusherInstance() {
  if (!pusherInstance) {
    Pusher.logToConsole = false;
    pusherInstance = new Pusher("f1b255b7c74088ee23a6", {
      cluster: "mt1",
    });
  }
  return pusherInstance;
}

export function usePusherChannel(channelName, eventName, callback) {
  
  const savedCallback = useRef(callback)

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    if (!channelName || !eventName) return;

    const pusher = getPusherInstance();
    const channel = pusher.subscribe(channelName);

    const eventHandler = (data) => {
      if (savedCallback.current) {
        savedCallback.current(data);
      }
    };

    channel.bind(eventName, eventHandler);

    return () => {
      channel.unbind(eventName, eventHandler);
      pusher.unsubscribe(channelName);
    };
  }, [channelName, eventName]);
}
